/**
 * 进门登录 store BRM禁止与其耦合
 */

import { getStorageAuthInfo } from '@/utils/storageOperateApi';
import store from '@/store';
import { LOCAL_STORAGE_KEY } from '@/constants';
import { checkToken } from '@/jmHttp/api/common';
import { storage } from '@/utils/storageOperateApi';
import { ElMessageBox } from 'element-plus';
import router from '@/router';
import { getJmParams } from '@/apis/api/scheduleManage';
import { ref } from 'vue';
import i18n from '@/plugins/i18n';
import slsLogger from '@/utils/slsLogger';
export default {
  namespaced: true,
  state: {
    userInfo: null,
    showConfirmDialog: false
  },
  getters: {
    /**
     * 用户信息 仅限用户信息
     * @param {*} state
     * @returns
     */
    userInfo() {
      const userInfo = ref(getStorageAuthInfo(LOCAL_STORAGE_KEY.JM_AUTH_INFO));
      store.dispatch('jm/setUserInfo', userInfo.value);
      return userInfo.value;
    }
  },
  mutations: {
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
    initState(state, payload) {
      state.userInfo = payload;
    },
    clearState(state) {
      state.userInfo = null;
    },
    showMessage(state) {
      state.showConfirmDialog = true;
    },
    hideMessage(state) {
      state.showConfirmDialog = false;
    }
  },
  actions: {
    setUserInfo({ commit }, payload) {
      commit('setUserInfo', payload);
    },
    checkTokenAction({ commit }) {
      return new Promise((resolve, reject) => {
        checkToken()
          .then((res) => {
            if (!res.data) {
              const cooperationInfo = storage.get(LOCAL_STORAGE_KEY.COOPERATION, true);
              const flag = cooperationInfo && cooperationInfo.userInfo && cooperationInfo.userChannel;

              ElMessageBox.alert('账号被挤下线了,请重新登录', i18n.global.t('common.tip.tips'), {
                customClass: 'w480 message-box-normal',
                showCancelButton: false,
                confirmButtonText: flag ? '刷新' : '前往',
                callback: () => {
                  if (flag) {
                    // 判断本地是否存在用户登录信息 有则自动登录
                    storage.clear();
                    const hasQuery = window.location.search;
                    const query = `${hasQuery ? '&' : '?'}userInfo=${encodeURIComponent(
                      cooperationInfo.userInfo
                    )}&userChannel=${cooperationInfo.userChannel}`;
                    return (window.location.href = `${window.location.href}${query}`);
                  } else {
                    store.dispatch('logoutAction').then(() => {
                      router.push(
                        `/login?redirect_uri=${encodeURIComponent(window.location.pathname + window.location.search)}`
                      );
                    });
                  }
                }
              });
              return;
            }
            const oldData = storage.get(LOCAL_STORAGE_KEY.JM_AUTH_INFO, true);
            commit('setUserInfo', Object.assign(oldData, res.data));
            storage.set(LOCAL_STORAGE_KEY.JM_AUTH_INFO, Object.assign(oldData, res.data), null, true);
            slsLogger.console({
              action: 'jm',
              message: 'checkTokenAction：合并接口返回并更新本地 JM_AUTH_INFO',
              extra: { path: typeof window !== 'undefined' ? window.location.pathname : '' }
            });
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },

    getJmParamsAction({ commit }) {
      const userInfo = store.getters['userInfo'];
      const { comeinUid } = userInfo || {};
      if (!comeinUid) {
        return Promise.reject('comeinUid is null');
      }
      return new Promise((resolve, reject) => {
        getJmParams({ comeinUid })
          .then((res) => {
            if (res.code !== 0) {
              reject(res);
              return;
            }
            const oldData = storage.get(LOCAL_STORAGE_KEY.JM_AUTH_INFO, true);
            if (!oldData) return resolve({ data: {} });
            commit('setUserInfo', Object.assign(oldData, { webtoken: res.data.webToken, token: res.data.webToken }));
            storage.set(
              LOCAL_STORAGE_KEY.JM_AUTH_INFO,
              Object.assign(oldData, { webtoken: res.data.webToken, token: res.data.webToken }),
              null,
              true
            );
            slsLogger.console({
              action: 'jm',
              message: 'getJmParamsAction：更新本地 webtoken',
              extra: { path: typeof window !== 'undefined' ? window.location.pathname : '' }
            });
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },

    /**
     * 根据用户jm token 获取用户信息
     */
    getUserInfoByToken(store, payload) {
      return new Promise((resolve, reject) => {
        checkToken(
          {},
          {
            headers: {
              token: payload.token
            }
          }
        )
          .then((res) => {
            if (res.data) return resolve(res);
            reject();
          })
          .catch(() => {
            reject();
          });
      });
    }
  }
};
